import { render, staticRenderFns } from "./TemplateReportAudience.vue?vue&type=template&id=a01c7210"
import script from "./TemplateReportAudience.vue?vue&type=script&lang=js"
export * from "./TemplateReportAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports